import { Icon, Text, XStack, YStack } from '@frontend/web-react';

export type PromotionBannerProps = {
  onDismiss?: () => void;
  promotionCode?: string;
  promotionDescription?: string;
  promotionName: string;
};

export const PromotionBanner = ({
  onDismiss,
  promotionCode,
  promotionDescription,
  promotionName,
}: PromotionBannerProps) => {
  return (
    <XStack alignItems="center" className="rounded-lg bg-cool-100" gapX="md" justifyContent="between" p="md">
      <XStack alignItems="center" gapX="md">
        <YStack alignItems="center" className="size-xxl shrink-0 rounded-md bg-cool-300" justifyContent="center">
          <Icon colorOverride="#292929" name="CoinsIcon" size={18} />
        </YStack>
        <YStack className="shrink" gapY="xs">
          <Text className="text-neutral-800" type="p-sm">
            Promotion Applied
          </Text>
          <YStack className="md:flex-row" gapX="sm" gapY="xs">
            <Text type="h6">{promotionCode || promotionName}:</Text>
            {promotionDescription ? <Text type="h6">{promotionDescription}</Text> : null}
          </YStack>
        </YStack>
      </XStack>
      {onDismiss ? (
        <Icon
          className="cursor-pointer rounded-sm bg-cool-100 p-xs"
          colorOverride="#9e9a94"
          name="IconX"
          onClick={onDismiss}
          size={18}
        />
      ) : null}
    </XStack>
  );
};
